import * as React from 'react';
import {connect} from 'react-redux';
import {IUserModelProps} from '../../model/UserModel';
import {submitUserForm} from '../../services/userService';
import {BasePage} from '../reusableComponents/BasePage';
import {FileInputButton} from '../reusableComponents/FormComponents/FileInputButton';
import {isFormEmpty, dispatch} from '../../utils/generalUtils';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {UserForm} from './UserForm';
import {Async} from '../reusableComponents/Async';
import {Loader} from '../reusableComponents/Loader/Loader';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {getAllModules} from '../../services/moduleService';
import {ModuleModel} from '../../model/ModuleModel';
import {actions} from 'react-redux-form';
import {getUserData} from '../../services/utilityServices';
import {OrgModel} from '../../model/OrgModel';
import {getAllOrg} from '../../services/organizationService';

export interface ICreateUserProps {
    history: IHistory;
    moduleInstances: ModuleModel[];
    organizationInstances: OrgModel;
}

export interface ICreateUserState {
    isLoading: boolean;
}

export class CreateUserImpl extends React.PureComponent<ICreateUserProps, ICreateUserState> {
    loggedInUser = getUserData();

    constructor(props: ICreateUserProps) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    public resetForm = () => {
        dispatch(actions.reset('forms.createUserForm'));
    }

    public refs: {
        file: FileInputButton;
        profilePic: UserForm;
    };

    public promise = async () => {
        if (this.loggedInUser.accessLevel === 'L1') {
            getAllOrg();
        } else if (this.loggedInUser.accessLevel === 'L2') {
            await getAllModules();
        }
    }

    public handleSubmit = async (values) => {
        const ignoreList = [];
        if (values.accessLevel && (values.accessLevel === 'L1' || values.accessLevel === 'L3')) {
            ignoreList.push('organization');
        }
        else if (values.accessLevel && values.accessLevel === 'L2') {
            values.organization = this.loggedInUser.OrganizationName;
        }
        if (isFormEmpty(values, ignoreList)) {
            return;
        }
        
        try {
            this.setState({ isLoading: true });
            const result = await submitUserForm(values, null, this.props.history);
            this.setState({ isLoading: false });
            return result;
        } catch (error) {
            this.setState({ isLoading: false });
            throw error;
        }
    }

    public render() {

        return <BasePage title="Create New User" icon="user-plus">
            <Async
                identifier="CreateUser"
                promise={this.promise}
                content={
                    <UserForm
                        moduleInstances={this.props.moduleInstances}
                        id="CreateUser"
                        loadDefaultValues={this.resetForm}
                        orgsList={this.props.organizationInstances}
                        loggedInUser={this.loggedInUser}
                        ref="profilePic"
                        model="forms.createUserForm"
                        onSubmit={this.handleSubmit}
                    />
                }
                loader={<Loader type="async"/>}
                error={<ErrorPage/>}
            />
        </BasePage>;
    }
}

export function mapStateToProps(state) {
    const moduleInstances = ModuleModel.list();
    const organizationInstances = OrgModel.list();
    return {
        moduleInstances,
        organizationInstances
    };
}

export const CreateUser = withRouter(connect<{}, {}, ICreateUserProps>(mapStateToProps)(CreateUserImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Users/CreateUser.tsx